import {getUserRefreshTokenToCache, getUserToCache, removeUserToCache, setUserOnCache} from "./cache-helper";
import AboutApi from "../apis/authorization/login-api";
import {cloneDeep} from "lodash";
import INITIAL_STATE_USER_SLICE from "../slice/state.userSlice"
let intialStateAuthUser={
    ...INITIAL_STATE_USER_SLICE
}

export async function initializeAppState() {
    let authUser=getUserToCache()
    if(authUser){
        intialStateAuthUser=cloneDeep(authUser)
        let refreshToken=getUserRefreshTokenToCache()
        try {
            let refreshResponse=await AboutApi.getAccessToken({refreshToken:refreshToken},null)
            intialStateAuthUser.token=refreshResponse.data.token
            intialStateAuthUser.isAuthenticated=true
            intialStateAuthUser.refreshToken=refreshResponse.data.refreshToken || refreshToken
            setUserOnCache(JSON.stringify(intialStateAuthUser))
        }catch (e) {
            removeUserToCache()
            intialStateAuthUser.token=null
            intialStateAuthUser.isAuthenticated=false
            intialStateAuthUser.refreshToken=null
        }
    }
    return {authUser:intialStateAuthUser}

}
